export default "__VITE_ASSET__5f5bb6db__"